import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class RadioQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.RADIO;
  options: { key: string; value: string; imageSrc: string }[];

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
